import { render, staticRenderFns } from "./OleMiss_AtomicEmission_HeliumResults.vue?vue&type=template&id=bfc5a34a&scoped=true&"
import script from "./OleMiss_AtomicEmission_HeliumResults.vue?vue&type=script&lang=js&"
export * from "./OleMiss_AtomicEmission_HeliumResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc5a34a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VSimpleTable})
